import NiceModal from '@ebay/nice-modal-react';
import dynamic from 'next/dynamic';

export interface ThirdPartyLoggingInProps {
  /** 第三方登录提供商 */
  provider?: 'google' | 'telegram';
}

// 使用 dynamic 导出 default，保持按需加载（仅客户端渲染）
export default dynamic(() => import('./third-party-logging-in'), { ssr: false });

export const THIRD_PARTY_LOGGING_IN_MODAL = 'third-party-logging-in-modal';

let isRegistered = false;

async function ensureModalRegistered() {
  if (isRegistered) return;
  const modalModule = await import('./third-party-logging-in');
  NiceModal.register(THIRD_PARTY_LOGGING_IN_MODAL, modalModule.default);
  isRegistered = true;
}

export const registerThirdPartyLoggingInModal = async () => {
  await ensureModalRegistered();
};

/**
 * 显示第三方登录中组件（按需加载）
 *
 * 仅在需要展示时，才动态加载和注册组件，减少首屏体积。
 * 同时在这里加 15 秒兜底关闭，避免组件内部受可见状态时机影响。
 */
export const showThirdPartyLoggingIn = async (params?: ThirdPartyLoggingInProps) => {
  await ensureModalRegistered();

  // 兜底：15 秒后自动关闭（多次调用 NiceModal.hide 是幂等的）
  setTimeout(() => {
    NiceModal.hide(THIRD_PARTY_LOGGING_IN_MODAL);
  }, 15000);

  return NiceModal.show(THIRD_PARTY_LOGGING_IN_MODAL, params);
};

export const hideThirdPartyLoggingIn = () => {
  NiceModal.hide(THIRD_PARTY_LOGGING_IN_MODAL);
};
